import { VisitHistoryModal } from '../ui';
import { useModalStore } from '@/shared/lib';

type Params = {
  onBack: () => void;
};

export function useVisitHistoryModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openVisitHistoryModal = ({ onBack }: Params) => {
    showDialogComponent({
      component: <VisitHistoryModal onBack={onBack} />,
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto bg-secondary-bg border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openVisitHistoryModal };
}
